<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-6">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">chat</mat-icon>
      <h1 class="text-xl md:text-2xl font-bold text-gray-800">Configuración WhatsApp OTP</h1>
    </div>
    <div class="flex flex-wrap gap-2">
      <button type="button" (click)="onAddNumber()" [disabled]="loading"
        [style.opacity]="loading ? '0.5' : '1'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 16px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">add</mat-icon>
        Agregar número
      </button>
      <button type="button" (click)="refreshAll()"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #374151;">refresh</mat-icon>
        Actualizar
      </button>
    </div>
  </div>

  <!-- Indicador de Carga General (solo acciones del operador, no el polling) -->
  <div *ngIf="loading" class="flex justify-center items-center p-4">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Números de WhatsApp: el base (registro) y los extras (pagadores) -->
  <div *ngIf="!numbersLoaded" class="flex justify-center items-center p-8">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div *ngIf="numbersLoaded && numbers.length === 0" class="text-center py-8 mb-6 bg-white rounded-2xl shadow-md border border-gray-100">
    <mat-icon class="text-gray-400" style="font-size: 40px; width: 40px; height: 40px;" fontIcon="wifi_off"></mat-icon>
    <p class="text-gray-500 mt-2">No se pudieron cargar los números de WhatsApp</p>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
    <div *ngFor="let n of numbers; trackBy: trackByNumberId"
      class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
        class="flex items-center justify-between gap-2">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px; min-width: 0;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0;">wifi</mat-icon>
          <span class="truncate">{{ n.label }}</span>
        </h2>
        <span class="px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap"
          [ngClass]="n.role === 'registro' ? 'bg-green-100 text-green-700' : 'bg-purple-100 text-purple-700'">
          {{ getRoleLabel(n.role) }}
        </span>
      </div>

      <div class="flex flex-col items-center gap-4 p-5 min-h-[280px]">
        <!-- Icono y Estado -->
        <div class="flex flex-col items-center gap-3">
          <mat-icon
            [ngClass]="getStatusColor(n.status)"
            [fontIcon]="getStatusIcon(n.status)"
            style="font-size: 56px; width: 56px; height: 56px;">
          </mat-icon>
          <span class="px-4 py-1.5 text-sm font-semibold rounded-full" [ngClass]="getStatusBadgeClass(n.status)">
            {{ getStatusLabel(n.status) }}
          </span>
          <p class="text-gray-500 text-xs text-center">
            {{ n.role === 'registro'
              ? 'Envía los OTP de registro de usuarios de Aguacate'
              : 'Envía solo OTP de pagadores (marca blanca)' }}
          </p>
        </div>

        <!-- Contenedor QR/estados -->
        <div class="w-full flex justify-center items-center min-h-[160px]">
          <!-- QR Code -->
          <div *ngIf="n.status === 'QR_READY' && n.qr"
            class="flex flex-col items-center gap-2 p-3 border-2 border-dashed border-gray-300 rounded-lg bg-white">
            <p class="text-gray-600 text-center text-xs">Escanea con el WhatsApp de este número</p>
            <img [src]="n.qr" alt="QR de WhatsApp" class="w-36 h-36 object-contain" />
          </div>

          <!-- QR pedido pero todavía no llegó -->
          <div *ngIf="n.status === 'QR_READY' && !n.qr" class="flex flex-col items-center gap-2">
            <mat-spinner diameter="24"></mat-spinner>
            <p class="text-gray-600 text-sm">Cargando QR...</p>
          </div>

          <!-- Conectando -->
          <div *ngIf="n.status === 'CONNECTING'" class="flex flex-col items-center gap-2">
            <mat-spinner diameter="24"></mat-spinner>
            <p class="text-gray-600 text-sm">
              {{ n.hasStoredCredentials ? 'Reconectando con la sesión guardada...' : 'Iniciando conexión...' }}
            </p>
          </div>

          <!-- Conectado -->
          <div *ngIf="n.status === 'CONNECTED'" class="text-center p-4 bg-green-50 rounded-lg w-full">
            <mat-icon class="text-green-500" fontIcon="verified" style="font-size: 48px; width: 48px; height: 48px;"></mat-icon>
            <p class="text-green-700 font-medium mt-2">WhatsApp conectado</p>

            <div *ngIf="n.connectedNumber" class="my-2 p-2 bg-white rounded border border-green-200">
              <p class="text-gray-700 text-sm font-medium">
                <mat-icon class="text-sm align-middle text-green-600" fontIcon="phone"></mat-icon>
                +{{ n.connectedNumber }}
              </p>
              <p *ngIf="n.connectedName" class="text-gray-500 text-xs">{{ n.connectedName }}</p>
            </div>

            <p class="text-gray-500 text-sm">Listo para enviar OTPs</p>
          </div>

          <!-- Desconectado -->
          <div *ngIf="n.status === 'DISCONNECTED'" class="text-center p-4">
            <p class="text-gray-500 text-sm">Haz clic en "Conectar" para vincular WhatsApp</p>
            <p *ngIf="n.role === 'registro'" class="text-red-600 text-xs mt-2">
              Mientras esté desconectado, los usuarios nuevos no reciben su código de registro.
            </p>
            <!-- Estando DISCONNECTED no hay reconexión en curso: la sesión
                 guardada solo se usa al tocar "Conectar". -->
            <div *ngIf="n.hasStoredCredentials" class="mt-2 p-2 bg-blue-50 rounded-lg">
              <p class="text-blue-600 text-xs">
                <mat-icon class="text-sm align-middle" fontIcon="info"></mat-icon>
                Hay una sesión guardada: al conectar se reutiliza sin escanear QR.
              </p>
            </div>
          </div>
        </div>

        <p class="text-gray-500 text-xs">
          Mensajes este minuto: <span class="font-semibold text-gray-700">{{ n.messagesThisMinute }}</span>
        </p>

        <!-- Botones de Acción -->
        <div class="flex flex-wrap gap-2 w-full justify-center">
          <button *ngIf="n.status === 'DISCONNECTED' || n.status === 'QR_READY'" type="button" (click)="onConnect(n)" [disabled]="loading"
            [style.opacity]="loading ? '0.5' : '1'"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;" [fontIcon]="n.status === 'QR_READY' ? 'qr_code_2' : 'link'"></mat-icon>
            {{ n.status === 'QR_READY' ? 'Nuevo QR' : 'Conectar' }}
          </button>

          <!-- Cancelar: detiene la espera sin borrar la sesión (stop, no disconnect) -->
          <button *ngIf="isTransitional(n.status)" type="button" (click)="onStop(n)" [disabled]="loading"
            [style.opacity]="loading ? '0.5' : '1'"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;" fontIcon="cancel"></mat-icon>
            Cancelar
          </button>

          <button *ngIf="canDisconnect(n)" type="button" (click)="onDisconnect(n)" [disabled]="loading"
            [style.opacity]="loading ? '0.5' : '1'"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;" fontIcon="link_off"></mat-icon>
            Desconectar
          </button>

          <button *ngIf="n.role === 'pagador'" type="button" (click)="onRemove(n)" [disabled]="loading"
            [style.opacity]="loading ? '0.5' : '1'"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #dc2626; border: 1px solid #fecaca; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;" fontIcon="delete"></mat-icon>
            Quitar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
    <!-- Card Estadísticas (globales: todos los números) -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #fef3c7, #fde68a); padding: 16px 24px; border-bottom: 2px solid #fbbf24;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #92400e; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #92400e;">analytics</mat-icon>
          Estadísticas de OTP (24h, todos los números)
        </h2>
      </div>
      <div class="p-5">
        <div *ngIf="!stats" class="text-center py-8">
          <mat-icon class="text-gray-400" style="font-size: 40px; width: 40px; height: 40px;" fontIcon="analytics"></mat-icon>
          <p class="text-gray-500 mt-2">No hay estadísticas disponibles</p>
        </div>

        <div *ngIf="stats" class="grid grid-cols-2 gap-3">
          <div class="bg-yellow-50 rounded-lg p-3 text-center">
            <p class="text-2xl font-bold text-yellow-600">{{ stats.pending }}</p>
            <p class="text-xs text-gray-600">Pendientes (vigentes)</p>
          </div>
          <div class="bg-green-50 rounded-lg p-3 text-center">
            <p class="text-2xl font-bold text-green-600">{{ stats.verified }}</p>
            <p class="text-xs text-gray-600">Verificados</p>
          </div>
          <div class="bg-gray-50 rounded-lg p-3 text-center">
            <p class="text-2xl font-bold text-gray-600">{{ stats.expired }}</p>
            <p class="text-xs text-gray-600">Expirados</p>
          </div>
          <div class="bg-red-50 rounded-lg p-3 text-center">
            <p class="text-2xl font-bold text-red-600">{{ stats.blocked }}</p>
            <p class="text-xs text-gray-600">Bloqueados</p>
          </div>
        </div>

        <!-- Rate Limit -->
        <div *ngIf="rateLimit" class="mt-4 p-3 bg-blue-50 rounded-lg">
          <div class="flex justify-between items-center mb-2">
            <span class="text-sm text-gray-600">Rate limit (número de registro):</span>
            <span class="font-bold text-sm">
              {{ rateLimit.messagesThisMinute }} / {{ rateLimit.maxPerMinute }} msg/min
            </span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-2">
            <div class="h-2 rounded-full transition-all"
              [ngClass]="{
                'bg-green-500': getRateLimitPercentage() < 50,
                'bg-yellow-500': getRateLimitPercentage() >= 50 && getRateLimitPercentage() < 80,
                'bg-red-500': getRateLimitPercentage() >= 80
              }"
              [style.width.%]="getRateLimitPercentage()">
            </div>
          </div>
        </div>

        <button type="button" (click)="onCleanupCache()" [disabled]="loading"
          [style.opacity]="loading ? '0.5' : '1'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; width: 100%; padding: 8px 24px; margin-top: 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;" fontIcon="cleaning_services"></mat-icon>
          Limpiar Cache
        </button>
      </div>
    </div>

    <!-- Card Enviar OTP de prueba (sale por el número de registro) -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100">
      <div class="rounded-t-2xl" style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">send</mat-icon>
          Enviar OTP de prueba
        </h2>
      </div>
      <div class="p-5">
        <div class="flex gap-2 items-start">
          <!-- Selector de país -->
          <div class="relative country-selector">
            <div class="flex items-center gap-1 px-3 py-3 border border-gray-300 rounded cursor-pointer bg-white hover:bg-gray-50 min-w-[100px]"
              (click)="toggleCountryDropdown()">
              <img [src]="'assets/flags/' + selectedCountryFlag" [alt]="selectedCountryCode" class="w-6 h-4 object-cover rounded-sm" />
              <span class="text-sm font-medium">{{ selectedCountryCode }}</span>
              <mat-icon class="text-gray-500" style="font-size: 18px; width: 18px; height: 18px;" fontIcon="arrow_drop_down"></mat-icon>
            </div>
            <div *ngIf="showCountryDropdown"
              class="absolute z-50 mt-1 w-56 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
              <div *ngFor="let country of countryPhoneOptions"
                class="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
                (click)="selectCountry(country.code, country.flag)">
                <img [src]="'assets/flags/' + country.flag" [alt]="country.name" class="w-6 h-4 object-cover rounded-sm" />
                <span class="text-sm">{{ country.code }}</span>
                <span class="text-sm text-gray-600">{{ country.name }}</span>
              </div>
            </div>
          </div>

          <mat-form-field appearance="outline" class="flex-1 modern-field" subscriptSizing="dynamic">
            <mat-label>Número de teléfono</mat-label>
            <input matInput [(ngModel)]="testPhoneNumber" placeholder="912345678"
              (keyup.enter)="onSendTestOTP()" maxlength="10" pattern="[0-9]*" />
          </mat-form-field>

          <button type="button" (click)="onSendTestOTP()"
            [disabled]="sendingTestOTP || !testPhoneNumber.trim()"
            [style.opacity]="(sendingTestOTP || !testPhoneNumber.trim()) ? '0.5' : '1'"
            style="display: inline-flex; align-items: center; gap: 4px; padding: 14px 16px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-spinner *ngIf="sendingTestOTP" diameter="20" class="inline-block"></mat-spinner>
            <mat-icon *ngIf="!sendingTestOTP" style="font-size: 18px; width: 18px; height: 18px; color: white;" fontIcon="send"></mat-icon>
            {{ sendingTestOTP ? '...' : 'Enviar' }}
          </button>
        </div>
        <p class="text-gray-400 text-xs mt-1">Selecciona el país e ingresa solo el número (sin código)</p>
        <div class="flex gap-2 items-start mt-3">
          <mat-form-field appearance="outline" class="flex-1 modern-field" subscriptSizing="dynamic">
            <mat-label>Enviar desde</mat-label>
            <mat-select [(ngModel)]="testNumberId">
              <mat-option *ngFor="let n of numbers; trackBy: trackByNumberId" [value]="n.id"
                [disabled]="n.status !== 'CONNECTED'">
                {{ n.label }}{{ n.connectedNumber ? ' (+' + n.connectedNumber + ')' : '' }}{{ n.status !== 'CONNECTED' ? ' · desconectado' : '' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="isPayerTestSender()" appearance="outline" class="flex-1 modern-field" subscriptSizing="dynamic">
            <mat-label>Nombre del cliente (ejemplo)</mat-label>
            <input matInput [(ngModel)]="testSenderName" maxlength="60" placeholder="Comercial Andes SpA" />
          </mat-form-field>
        </div>
        <p class="text-gray-400 text-xs mt-1" *ngIf="!isPayerTestSender()">El número de registro manda el mensaje de Aguacate.</p>
        <p class="text-gray-400 text-xs mt-1" *ngIf="isPayerTestSender()">Los números de pagadores mandan el mensaje sin marca Aguacate, con el nombre del cliente como encabezado.</p>
      </div>
    </div>
  </div>

  <!-- Card Historial OTP -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">sms</mat-icon>
        Historial de Mensajes OTP
      </h2>
    </div>
    <div class="p-5">
      <!-- Filtros -->
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Filtrar por teléfono</mat-label>
          <input matInput [(ngModel)]="filterPhone" (keyup.enter)="onFilterChange()" placeholder="Ej: 56912345678" />
          <mat-icon matSuffix fontIcon="search"></mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Estado</mat-label>
          <mat-select [(ngModel)]="filterStatus" (selectionChange)="onFilterChange()">
            <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="flex items-start">
          <button type="button" (click)="onFilterChange()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 14px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">filter_list</mat-icon>
            Filtrar
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="loadingMessages" class="flex justify-center p-4">
        <mat-spinner diameter="30"></mat-spinner>
      </div>

      <!-- Tabla Desktop -->
      <div *ngIf="!loadingMessages && messages.length > 0" class="hidden lg:block overflow-x-auto">
        <table mat-table [dataSource]="messages" class="w-full">
          <ng-container matColumnDef="otpId">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.otpId }}</span></td>
          </ng-container>

          <ng-container matColumnDef="phoneNumber">
            <th mat-header-cell *matHeaderCellDef>Teléfono</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">{{ row.phoneNumber }}</span></td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let row">
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="getOTPStatusClass(row.status)">
                {{ getOTPStatusLabel(row.status) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="purpose">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs">{{ getPurposeLabel(row.purpose) }}</span></td>
          </ng-container>

          <ng-container matColumnDef="sender">
            <th mat-header-cell *matHeaderCellDef>Enviado por</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs">{{ getSenderLabel(row.sender) }}</span></td>
          </ng-container>

          <ng-container matColumnDef="attempts">
            <th mat-header-cell *matHeaderCellDef>Intentos</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.attempts }}/{{ row.maxAttempts }}</span></td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Creado</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.createdAt | date:'dd/MM/yy HH:mm' }}</span></td>
          </ng-container>

          <ng-container matColumnDef="expiresAt">
            <th mat-header-cell *matHeaderCellDef>Expira</th>
            <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.expiresAt | date:'dd/MM/yy HH:mm' }}</span></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="messageColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: messageColumns"></tr>
        </table>
      </div>

      <!-- Cards Mobile -->
      <div *ngIf="!loadingMessages" class="lg:hidden space-y-2">
        <div *ngFor="let row of messages"
          class="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
          <div class="flex flex-col gap-1 flex-1 min-w-0">
            <div class="flex items-center gap-2">
              <span class="text-xs font-mono font-semibold text-gray-700">{{ row.phoneNumber }}</span>
              <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="getOTPStatusClass(row.status)">
                {{ getOTPStatusLabel(row.status) }}
              </span>
            </div>
            <div class="flex flex-wrap items-center gap-3 text-xs text-gray-400">
              <span>{{ row.createdAt | date:'dd/MM HH:mm' }}</span>
              <span>{{ row.attempts }}/{{ row.maxAttempts }} intentos</span>
              <span>{{ getPurposeLabel(row.purpose) }}</span>
              <span class="truncate">{{ getSenderLabel(row.sender) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loadingMessages && messages.length === 0" class="text-center py-8">
        <mat-icon class="text-gray-400" style="font-size: 40px; width: 40px; height: 40px;">sms</mat-icon>
        <p class="text-gray-500 mt-2">No hay mensajes OTP</p>
      </div>

      <!-- Paginador -->
      <mat-paginator
        *ngIf="totalMessages > 0"
        [length]="totalMessages"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 20, 50]"
        (page)="onPageChange($event)"
        showFirstLastButtons
        class="mt-4">
      </mat-paginator>
    </div>
  </div>
</div>
